import { usesPlatformChrome } from "../platform/pageChrome";
import { STORAGE_THEME_KEY } from "./tickitBrandTokens";

const SCANNER_PREFIXES = ["/Usher", "/event/live"];

function isScannerRoute(pathname = "") {
  if (!pathname) return false;
  if (SCANNER_PREFIXES.some((p) => pathname.startsWith(p))) return true;
  if (pathname.includes("/scanner")) return true;
  return false;
}

function isAdminRole(role) {
  return ["Admin", "Super", "Partner"].includes(role);
}

/** Effective theme: light | dark */
export function resolveThemeMode(pathname, role, userPreference) {
  if (isScannerRoute(pathname) || role === "Usher") {
    return "dark";
  }
  if (!usesPlatformChrome(pathname, role) || !isAdminRole(role)) {
    return "light";
  }
  if (userPreference === "light" || userPreference === "dark") {
    return userPreference;
  }
  return "dark";
}

export function loadStoredThemePreference() {
  try {
    const v = localStorage.getItem(STORAGE_THEME_KEY);
    if (v === "light" || v === "dark") return v;
  } catch {
    /* ignore */
  }
  return "dark";
}

export function saveThemePreference(mode) {
  try {
    localStorage.setItem(STORAGE_THEME_KEY, mode);
  } catch {
    /* ignore */
  }
}

export function canToggleTheme(pathname, role) {
  return isAdminRole(role) && usesPlatformChrome(pathname, role) && !isScannerRoute(pathname);
}
